import * as Page from '../../components/content/page-header';
import { MainContent } from '../../components/layout/content';
import React, { useEffect, useState } from 'react';
import { PageHeader } from '../../components/layout/page-header';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { ReactComponent as Add } from '../../assets/icons/add2.svg';
import { ReactComponent as Move } from '../../assets/icons/move.svg';
import { ReactComponent as Fb } from '../../assets/icons/fb.svg';
import { ReactComponent as Ig } from '../../assets/icons/ig.svg';
import { ReactComponent as Yt } from '../../assets/icons/yt.svg';
import { ReactComponent as Send } from '../../assets/icons/send.svg';
import CollectionModal from '../../components/modals/collection-modal';
import { useParams } from 'react-router-dom';
import { axiosInstance } from '../../api/api';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const swapElements = (array: any, index1: number, index2: number): void => {
  const temp = array[index1];
  array[index1] = array[index2];
  array[index2] = temp;
};

export const EditChannel = (): JSX.Element => {
  const [showModal, setShowModal] = useState<number | undefined>(undefined);
  const { channelId } = useParams();
  const [, setIsLoading] = useState(false);
  const [slots, setSlots] = useState<any[]>([
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
  ]);

  async function fetchChannel(id: string): Promise<void> {
    try {
      const response = await axiosInstance().get(`/channels/${id}`);
      if (response.data?.channels) {
        setSlots(response.data.channels);
      }
      setIsLoading(true);
    } catch (error) {
      console.error(error);
      setIsLoading(true);
    }
  }

  useEffect(() => {
    void fetchChannel(channelId!);
  }, [channelId]);

  const handleCloseModal = (): void => {
    setShowModal(undefined);
  };

  const handleModalOpen = (slot: any): void => {
    setShowModal(slot);
  };

  const handleSuccess = async (slotIndex: number, values: any): Promise<void> => {
    slots[slotIndex] = values;
    const response = await axiosInstance().put(`/channels/${channelId as string}`, slots);
    console.log('response', response);
    handleCloseModal();
  };

  const deleteTile = (index: number): void => {
    const slotsCopy = [...slots];
    slotsCopy[index] = undefined;
    setSlots(slotsCopy);
  };

  const AdTile = (props: {
    ratio: '16-9' | '4-3';
    index: number;
    onClick: (slot: any) => void;
  }): JSX.Element => {
    const tile = slots[props.index];
    const firstSlot = tile?.slots?.[0];

    return (
      <Draggable key={props.index} index={props.index} draggableId={`${props.index}`}>
        {(provided, snapshot): JSX.Element => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={{
              // default item style
              padding: '8px 16px',
              // default drag style
              ...provided.draggableProps.style,
              // customized drag style
              opacity: snapshot.isDragging ? 0.5 : 1,
            }}>
            <div
              className={`ad-tile tile-${props.ratio}`}
              style={{
                ...(firstSlot?.image ? { backgroundImage: `url(${firstSlot?.image})` } : {}),
              }}
              onClick={firstSlot ? (): void => props.onClick(props.index) : undefined}>
              <span className="move-handler" {...provided.dragHandleProps}>
                <Move />
              </span>
              {tile && (
                <span className="delete-handler" onClick={(): void => deleteTile(props.index)}>
                  <Close />
                </span>
              )}
              {!tile && (
                <span className="delete-handler" onClick={(): void => handleModalOpen(props.index)}>
                  <Add />
                </span>
              )}
              {firstSlot && <strong className="tile-title">/{firstSlot.title}</strong>}
            </div>
          </div>
        )}
      </Draggable>
    );
  };

  const handleDragEnd = ({ destination, source }: any): void => {
    if (typeof destination?.index === 'number' && typeof source?.index === 'number') {
      swapElements(slots, source.index, destination.index);
    }
  };

  return (
    <>
      <Page.Header>
        <PageHeader
          title="Edit channel"
          buttons={[
            { title: 'Cancel', type: 'link', location: `/channels/${channelId!}` },
            { title: 'Save', type: 'primary', location: `/channels/${channelId!}` },
          ]}
        />
      </Page.Header>
      <MainContent className="edit-channel">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable">
            {(provided): JSX.Element => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <div className="channel-content">
                  <div className="small-column">
                    <AdTile ratio={'16-9'} index={0} onClick={handleModalOpen} />
                    <AdTile ratio={'16-9'} index={1} onClick={handleModalOpen} />
                  </div>
                  <div className="big-column">
                    <AdTile ratio={'16-9'} index={2} onClick={handleModalOpen} />
                  </div>
                  <div className="small-column">
                    <AdTile ratio={'16-9'} index={3} onClick={handleModalOpen} />
                    <AdTile ratio={'16-9'} index={4} onClick={handleModalOpen} />
                  </div>
                </div>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div className="channel-footer">
          <div className="small-column">
            <div className="footer-item channel-footer-logo">
              <Logo />
            </div>
          </div>
          <div className="big-column">
            <div className="footer-item">
              <div className="channel-author">
                {slots?.[2]?.avatar && (
                  <span className="avatar">
                    <img src={slots?.[2]?.avatar} />
                  </span>
                )}
                <div className="channel-author-details">
                  {slots?.[2]?.name && <strong>{slots?.[2]?.name}</strong>}
                  {slots?.[2]?.username && <span>{slots?.[2]?.username}</span>}
                </div>
              </div>
            </div>
          </div>
          <div className="small-column">
            <div className="footer-item social-button-container">
              <div className="social-buttons">
                {slots?.[2]?.facebook && (
                  <a href={slots?.[2]?.facebook}>
                    <Fb />
                  </a>
                )}
                {slots?.[2]?.instagram && (
                  <a href={slots?.[2]?.instagram}>
                    <Ig />
                  </a>
                )}
                {slots?.[2]?.youtube && (
                  <a href={slots?.[2]?.youtube}>
                    <Yt />
                  </a>
                )}
              </div>
              <div className="social-buttons">
                {slots?.[2]?.telegram && (
                  <a href={slots?.[2]?.telegram}>
                    <Send />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        <CollectionModal
          show={typeof showModal === 'number'}
          slotIndex={showModal}
          slot={slots[showModal!]}
          onClose={handleCloseModal}
          onSave={handleSuccess}
        />
      </MainContent>
    </>
  );
};
